module.exports = __webpack_public_path__ + "img/SalesAdvisor-icon.3b8339a9.svg";